import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var GlobeSlated01 = function GlobeSlated01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18.6317 2.3682c4.491 4.491 4.491 11.7724 0 16.2634-4.3009 4.3009-11.1608 4.483-15.6783.5464-.197-.1716-.2956-.2575-.34-.3748a.52.52 0 0 1-.011-.3219c.0362-.1201.1347-.2185.3315-.4154l2.2152-2.2152M18 10.4999c0 4.1421-3.3578 7.5-7.5 7.5S3 14.642 3 10.4999s3.3579-7.5 7.5-7.5 7.5 3.3579 7.5 7.5"
    })
  }));
};
export default GlobeSlated01;